module.exports = __webpack_public_path__ + "img/xingqu.8ff75309.png";